import { Outlet, Navigate } from "react-router-dom";
import { AdminSidebarProvider, useAdminSidebar } from "@/contexts/AdminSidebarContext";
import AdminSidebar from "@/components/AdminSidebar";
import "@/styles/szadmin.css";

// A live admin session needs either a current access token or a refresh token
// the silent-refresh interceptor (utils/adminAxios.js) can mint a new access
// token from. With neither, the session is gone.
function hasAdminAuth() {
  try {
    return !!(
      localStorage.getItem("shootzu_admin_token") ||
      localStorage.getItem("shootzu_admin_refresh_token")
    );
  } catch (_) {
    return false;
  }
}

function AdminLayoutInner() {
  const { collapsed } = useAdminSidebar();

  return (
    <div className="sz-root min-h-screen flex" style={{ background: "var(--sz-page)" }}>
      <AdminSidebar />

      {/* Content area — sidebar is fixed; offset matches rail width */}
      <main
        className={`szscroll flex-1 min-w-0 h-screen overflow-y-auto transition-[margin] duration-[260ms] ${
          collapsed ? "lg:ml-[66px]" : "lg:ml-[248px]"
        }`}
      >
        <Outlet />
      </main>
    </div>
  );
}

export default function AdminLayout() {
  // Guard synchronously, before rendering any admin page. Admin pages fire API
  // calls on mount; rendering them while logged out would spray doomed /api/admin
  // requests (now 401 under enforcement). Redirecting here instead means a
  // logged-out admin URL goes straight to the login with no wasted calls.
  if (!hasAdminAuth()) {
    return <Navigate to="/szadmin?expired=true" replace />;
  }

  return (
    <AdminSidebarProvider>
      <AdminLayoutInner />
    </AdminSidebarProvider>
  );
}
